import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getTrips(options = {}) {
	return _apiRequestWrap(
		ModulesMap.TRIPS,
		ModulesConfigMap[ModulesMap.TRIPS].GET_TRIPS,
		options
	)
}
function _getTrip(options = {}) {
	return _apiRequestWrap(
		ModulesMap.TRIPS,
		ModulesConfigMap[ModulesMap.TRIPS].GET_TRIP,
		options
	)
}
function _getTripsPopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.TRIPS,
		ModulesConfigMap[ModulesMap.TRIPS].GET_TRIPS_POPUP,
		options
	)
}
function _getTripsPreview(options = {}) {

	return _apiRequestWrap(
		ModulesMap.TRIPS,
		ModulesConfigMap[ModulesMap.TRIPS].GET_TRIPS_PREVIEW,
		options
	)
}


export default {
	[ModulesConfigMap[ModulesMap.TRIPS].GET_TRIPS]: _getTrips,
  [ModulesConfigMap[ModulesMap.TRIPS].GET_TRIP]: _getTrip,
  [ModulesConfigMap[ModulesMap.TRIPS].GET_TRIPS_POPUP]: _getTripsPopup,
	[ModulesConfigMap[ModulesMap.TRIPS].GET_TRIPS_PREVIEW]: _getTripsPreview,

}